import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { normalizePermissions, SUPER_PERMISSION } from '../utils/permission.utils'

const canAccessRoute = (permissions, permission, superOnly) => {
  const normalizedPermissions = normalizePermissions(permissions)

  if (superOnly) {
    return normalizedPermissions.includes(SUPER_PERMISSION)
  }

  if (!permission) {
    return true
  }

  return normalizedPermissions.includes(SUPER_PERMISSION) || normalizedPermissions.includes(permission)
}

const canAccessAnyRoute = (permissions, anyOf = []) => {
  const normalizedPermissions = normalizePermissions(permissions)

  if (!Array.isArray(anyOf) || anyOf.length === 0) {
    return true
  }

  if (normalizedPermissions.includes(SUPER_PERMISSION)) {
    return true
  }

  return anyOf.some((permission) => normalizedPermissions.includes(permission))
}

export const PrivateRoute = ({
  component: Component,
  children,
  permission,
  anyOf,
  superOnly = false,
  ...rest
}) => {
  const permissions = useSelector((state) => state.admin.permissions)

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!localStorage.getItem('token')) {
          return (
            <Redirect
              to={{
                pathname: '/admin/login',
                state: { from: props.location },
              }}
            />
          )
        }

        if (!canAccessRoute(permissions, permission, superOnly) || !canAccessAnyRoute(permissions, anyOf)) {
          return (
            <Redirect
              to={{
                pathname: '/admin/v2/home',
                state: { from: props.location },
              }}
            />
          )
        }

        if (Component) {
          return <Component {...props} />
        }

        if (typeof children === 'function') {
          return children(props)
        }

        return children || null
      }}
    />
  )
}
